export const ACCOUNT_APPROVED_STATUS = {
  'Approved': 'Approved',
  'Pending': 'Pending',
  'Disqualified': 'Disqualified',
  'Out of Jurisdiction': 'Out of Jurisdiction',
  'Pending Clarification': 'Pending Clarification',
}